import React, { useState, useRef, useEffect } from 'react';

const MultiSelectDropdown = ({ label, options, selected = [], onChange, placeholder = 'Select...' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isGrouped = options.length > 0 && options[0].group !== undefined;

  const toggle = (opt) => {
    onChange(selected.includes(opt) ? selected.filter(s => s !== opt) : [...selected, opt]);
  };

  const displayText = selected.length === 0
    ? placeholder
    : selected.length <= 2
      ? selected.join(', ')
      : `${selected.slice(0, 2).join(', ')}, +${selected.length - 2} more`;

  const renderItem = (opt) => (
    <div
      key={opt}
      onClick={() => toggle(opt)}
      style={{
        padding: '8px 12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px',
        fontSize: '13px', background: selected.includes(opt) ? 'var(--cream)' : 'transparent',
      }}
    >
      <span style={{ width: '16px' }}>{selected.includes(opt) ? '✓' : ''}</span>
      <span>{opt}</span>
    </div>
  );

  return (
    <div className="edit-field" ref={ref} style={{ position: 'relative' }}>
      <label className="edit-label">{label}</label>
      <div
        className="edit-input"
        onClick={() => setOpen(o => !o)}
        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <span style={{ color: selected.length === 0 ? 'var(--muted)' : 'inherit' }}>{displayText}</span>
        <span style={{ color: 'var(--muted)' }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10,
          background: 'white', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
          maxHeight: '280px', overflowY: 'auto', marginTop: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        }}>
          {isGrouped
            ? options.map(g => (
                <div key={g.group}>
                  <div style={{
                    padding: '6px 12px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
                    letterSpacing: '0.05em', color: 'var(--muted)', background: 'var(--cream)',
                    position: 'sticky', top: 0,
                  }}>
                    {g.group}
                  </div>
                  {g.items.map(renderItem)}
                </div>
              ))
            : options.map(renderItem)
          }
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;